import { ButtonBase, styled } from '@ori-ui/mui';

export const BurgerMenuTabRoot = styled(ButtonBase)<{ ownerState: { isActive: boolean } }>(({ ownerState, theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.spacing(0, 0, 1, 1),
  color: theme.palette.text.primary,
  display: 'flex',
  fontSize: theme.typography.overline.fontSize,
  fontWeight: theme.typography.fontWeightBold,
  justifyContent: 'flex-start',
  textTransform: 'uppercase',
  width: '50%',

  ...(ownerState.isActive && {
    backgroundColor: theme.palette.common.white,
  }),

  '&::before': {
    fontSize: theme.typography.pxToRem(29),
    margin: theme.spacing(0, 3),
  },
}));

export const BurgerMenuTabPrefixWrapper = styled('div')<{ ownerState: { isLoggedIn?: boolean } }>(
  ({ ownerState, theme }) => ({
    borderRadius: '50%',
    display: 'flex',
    fontSize: theme.typography.pxToRem(29),

    margin: theme.spacing(3, 2),

    svg: {
      width: 24,
      height: 24,
    },

    ...(ownerState.isLoggedIn && {
      borderRadius: '50%',
      color: theme.palette.common.white,
      display: 'flex',
      fontSize: theme.typography.pxToRem(26),
      height: 26,
    }),
  }),
);

export const BurgerMenuTabLabelWrapper = styled('div')(({ theme }) => ({
  marginRight: theme.spacing(3),
  overflow: 'hidden',
  textAlign: 'left',
  textOverflow: 'ellipsis',
  width: '100%',
}));
